
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_TEL_ACTION_TYPE = createActionTypes('tel/GET');
export const TEL_CLEAR_ACTION_TYPE = 'tel/CLEAR';

export default function getActions(dispatch) {
    return {
        clear: () => dispatch({
            type: TEL_CLEAR_ACTION_TYPE
        }),
        getTel: (token, projectId, katuzeKod, isknDate, cisloLv) => dispatch({
            type: GET_TEL_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod, isknDate, cisloLv,
            operation: GET_TEL_ACTION_TYPE.DEFAULT
        })
    };
}

function* workGetTel(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: GET_TEL_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_TEL_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, GET_TEL_ACTION_TYPE);
    }
}

export function* watchGetTel(options) {
    yield takeEvery(
        GET_TEL_ACTION_TYPE.DEFAULT, workGetTel, options,
        'Vyhledání listu vlastnictví'
    );
}
